module.exports = __webpack_public_path__ + "img/dfeb413fa0c8009103732c2735155e56.png";